export default "__VITE_ASSET__KiqomPBf71NN3phYPN5sRQ__"